import { Component, OnInit, ViewChild, Input, Output, EventEmitter, SimpleChanges, AfterViewInit, OnChanges } from '@angular/core';
import { PageEvent, MatPaginator } from '@angular/material/paginator';
import { Pagination } from '../../models/pagination';
import { ExperienceI18nService } from 'src/app/core/experience/experience-i18n.service';
import { ThemeScope } from 'src/app/core/theme/theme-scope';

@Component({
  selector: 'app-card-table',
  templateUrl: './card-table.component.html',
  styleUrls: ['./card-table.component.scss']
})
export class CardTableComponent implements OnInit, OnChanges, AfterViewInit {
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @Input() title: string;
  @Input() elevated = false;
  @Input() showPaginator: boolean = true;
  @Input() metaData: Pagination;
  @Input() checkHasNextPage;
  /** Feature scope for Experience theme overrides (feature → component cascade). */
  @Input() themeScope: ThemeScope | string | null = null;
  /** When true, applies .card-overflow on the root card. */
  @Input() overflow = false;
  @Input() cardClass: string | string[] | Set<string> | { [klass: string]: any } | null = null;
  @Output('page') onPage = new EventEmitter<PageEvent>();
  @Output() hasNextPage = new EventEmitter<boolean>();

  constructor(private experienceI18n: ExperienceI18nService) { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!!this.paginator) {
      setTimeout(() => {
        this.hasNextPage.emit(this.paginator.hasNextPage())
      }, 100)
    }
  }

  ngAfterViewInit(): void {
    this.setDataSourceAttributes();
  }

  onPaginatorEvent(ev: PageEvent) {
    this.onPage.emit(ev);
    this.hasNextPage.emit(this.paginator.hasNextPage())
  }

  setDataSourceAttributes() {
    if (!!this.paginator) {
      this.paginator._intl.itemsPerPageLabel = this.experienceI18n.translate('shared.card-table.paginator.items-per-page', undefined, 'Registros por página');
      this.paginator._intl.firstPageLabel = this.experienceI18n.translate('shared.card-table.paginator.first-page', undefined, 'Primera página');
      this.paginator._intl.lastPageLabel = this.experienceI18n.translate('shared.card-table.paginator.last-page', undefined, 'Última página');
      this.paginator._intl.nextPageLabel = this.experienceI18n.translate('shared.card-table.paginator.next-page', undefined, 'Página siguiente');
      this.paginator._intl.previousPageLabel = this.experienceI18n.translate('shared.card-table.paginator.previous-page', undefined, 'Página anterior');
      this.hasNextPage.emit(this.paginator.hasNextPage())
    }
  }
}
